var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"bg-image-outer-wrapper",attrs:{"id":"app"}},[_c('headerMenu'),_c('router-view'),_c('lang'),_c('icon'),_c('footerMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }